import React, { PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Swal from "sweetalert2";

import { SiteRutas } from "../../request/RutasConfig";
import { Call_Center_Eliminar, } from "../../request/MantenimientosRequest";
import { Obtener_CallCenter_Empresa_Request } from "../../request/ParametroRequest";
import { Obtener_MenuOpciones } from "../../request/MenuRequest";
import { Notificacion } from "../../components/Util/Notificacion/Notificacion";
import CallCenterItfz from "./Interfaz/CallCenterItfz.jsx";

class CallCenter extends PureComponent {
    _isMounted = false;

    state = {
        Datos: {
            titulo: "Lista Call Center"
        },
        listaCallCenter: [],
        listaCallCenterOri: [],
        selectedCallCenter: 0,
        disabled: {
            Acciones: true,
            HabilitarAplicar: ""
        },
        buscar: "",
        menuId: 0,
        menuOpciones: [],
        showModalSeguridad: false,
        opcionValidar: 0,
        opcionSeleccionada: 1,
        autorizado: false,
        accion: 1,
        paginaActual: 1,
        cantidadRegistrosPaginaTabla: 10
    }

    componentDidMount = async () => {
        this._isMounted = true;

        let menuId = 0;
        if (this.props.location.state) {
            menuId = this.props.location.state.menuId;
        }

        menuId > 0 && this.obtener_opciones_menu(menuId);
        this.obtener_callcenter_por_empresa();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    obtener_opciones_menu = async (pMenu_Id) => {
        let response = await Obtener_MenuOpciones(this.props.token, pMenu_Id);
        if (response.Exitoso) {
            this._isMounted && this.setState({ menuId: pMenu_Id, menuOpciones: response.Datos });
        } else {
            Notificacion.error(response.Mensaje);
        }
    }

    obtener_callcenter_por_empresa = async () => {
        const response = await Obtener_CallCenter_Empresa_Request(this.props.token, this.props.empresa.Id);
        if (response.Exitoso) {
            this._isMounted && this.setState({ listaCallCenter: response.Datos, listaCallCenterOrig: response.Datos });
        } else {
            Notificacion.error(response.Mensaje);
        }
    }

    validarMenuOpcion = () => {
        let validar = false;

        const { autorizado, menuOpciones } = this.state;

        let resultado = menuOpciones.filter(item => item.Opcion_Id === 1);
        if (resultado.length > 0) {
            if (resultado[0].Validar && !autorizado) {
                this.setState({ showModalSeguridad: true, opcionValidar: resultado[0].Opcion_Id });
                validar = true;
            } else {
                validar = false;
            }
        } else {
            this.setState({ showModalSeguridad: true, opcionValidar: 1 });
            validar = true;
        }

        return validar;
    };

    cambiarTamanioPagina = (cantidad) => {
        this.setState({ cantidadRegistrosPaginaTabla: cantidad });
    }

    cambiarPagina = (pagina) => {
        this.setState({ paginaActual: pagina });
    }

    onActionResultModal = (pValido) => {
        if (pValido) {
            const opcionValidar = this.state.opcionValidar;
            this.setState({ showModalSeguridad: false, opcionSeleccionada: opcionValidar, opcionValidar: 0, autorizado: pValido },
                () => {
                    if (this.state.accion === 1) {
                        this.ingresarDatos();
                    } else {
                        this.actualizarDatos();
                    }
                }
            );
        }
    }

    handleCerrarModal = () => this.setState({ showModalSeguridad: false });

    validaSeleccionado = () => {
        let id = this.state.selectedCallCenter;
        if (id) {
            return true;
        } else {
            Notificacion.error("Debe seleccionar un registro");
            return false;
        }
    };

    actualizarDatos = () => {
        let validar = this.validarMenuOpcion();
        this._isMounted && this.setState({ accion: 2 });

        if (!validar) {
            let id = this.state.selectedCallCenter;
            let menuId = this.state.menuId;
            if (this.validaSeleccionado()) {
                this.props.history.push({ pathname: `${SiteRutas.CallCenterMantenimiento}/${id}`, state: { menuId: menuId } });
            }
        }
    }

    ingresarDatos = () => {
        let validar = this.validarMenuOpcion();
        this.setState({ accion: 1 });

        if (!validar) {
            let id = 0;
            let menuId = this.state.menuId;
            this.props.history.push({ pathname: `${SiteRutas.CallCenterMantenimiento}/${id}`, state: { menuId: menuId } });
        }
    }

    borrarDatos = async () => {
        if (this.validaSeleccionado()) {
            const id = this.state.selectedCallCenter;
            const resultado = await Call_Center_Eliminar(this.props.token, id, this.props.empresa.Id);
            if (resultado.Exitoso) {
                Notificacion.success("Se eliminó con éxito.");

                const response = await Obtener_CallCenter_Empresa_Request(this.props.token, this.props.empresa.Id);
                if (response.Exitoso) {
                    let paginaActual = this.state.paginaActual;
                    if (paginaActual > 1 && ((paginaActual - 1) * this.state.cantidadRegistrosPaginaTabla) >= response.Datos.length) {
                        paginaActual--;
                    }

                    this._isMounted && this.setState({ listaCallCenter: response.Datos, listaCallCenterOrig: response.Datos, selectedCallCenter: "", paginaActual });
                } else {
                    Notificacion.error(response.Mensaje);
                }
            } else {
                Notificacion.error("Error: " + resultado.Mensaje);
            }
        }
    }

    handleBorrar = () => {
        let resultado = false;
        if (this.validaSeleccionado()) {
            Swal.fire({
                title: "Eliminar Call Center",
                html: "<h4>¿Está seguro que desea eliminar el Call Center?</h4>",
                showCancelButton: true,
                confirmButtonText: "<h5>Sí</h5>",
                cancelButtonText: "<h5>No</h5>",
                reverseButtons: true,
                allowOutsideClick: false
            }).then((result) => {
                if (result.value) {
                    resultado = true;
                    this.borrarDatos();
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    resultado = false;
                }
            });
        }
        return resultado;
    }

    onRowSelect = (row, isSelected) => {
        let disabled = { ...this.state.disabled };
        disabled.Acciones = !isSelected;

        let selectedCallCenter = 0;

        if (isSelected) {
            selectedCallCenter = row.Id;
        }

        this._isMounted && this.setState({ disabled, selectedCallCenter });
    }

    onDoubleClick = (e, row, rowIndex) => {
        this.setState({ selectedCallCenter: row.Id }, () => this.actualizarDatos());
    }

    filtrarRegistro = (event) => {
        const { value } = event.target;
        const { listaCallCenterOrig } = this.state;
        this.setState({ buscar: value });

        let result = [];
        if (value.trim().length > 0) {

            result = listaCallCenterOrig.filter(item => item.Nombre.toUpperCase().indexOf(value.toUpperCase().trim()) != -1);
            if (result.length > 0) {
                this.setState({ listaCallCenter: result });
            } else {

                result = listaCallCenterOrig.filter(item => item.Id == value.trim());
                if (result.length > 0) {
                    this.setState({ listaCallCenter: result });
                }
            }
        } else {
            this.setState({ listaCallCenter: listaCallCenterOrig });
        }
    }

    onFocusInput = (event) => {
        event.target.value = this.state.buscar;
    };

    render() {
        const { Datos, listaCallCenter, menuId, opcionValidar, showModalSeguridad, buscar, paginaActual } = this.state;

        return (
            <CallCenterItfz
                token={this.props.token}
                listaCallCenter={listaCallCenter}
                Datos={Datos}
                onDoubleClick={this.onDoubleClick}
                onRowSelect={this.onRowSelect}
                actualizarDatos={this.actualizarDatos}
                ingresarDatos={this.ingresarDatos}
                handleBorrar={this.handleBorrar}
                filtrarRegistro={this.filtrarRegistro}
                onFocusInput={this.onFocusInput}
                handleCerrarModal={this.handleCerrarModal}
                menuId={menuId}
                opcionValidar={opcionValidar}
                showModalSeguridad={showModalSeguridad}
                onActionResultModal={this.onActionResultModal}
                buscar={buscar}
                paginaActual={paginaActual}
                onPageChange={this.cambiarPagina}
                onSizePerPageChange={this.cambiarTamanioPagina}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
    };
};

export default connect(mapStateToProps)(withRouter(memo(CallCenter)));
